<script setup lang="ts">
import { ref } from "vue";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogClose,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

const { ticketName } = defineProps<{ ticketName: string }>();

defineEmits<{ "close-ticket": [] }>();

const open = ref(false);
</script>

<template>
  <Dialog>
    <DialogTrigger>
      <Button @click="open = true"> Close ticket </Button>
    </DialogTrigger>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Close {{ ticketName }}</DialogTitle>
      </DialogHeader>
      <div class="flex flex-col justify-between">
        <p class="py-3">
          Are you sure you want to close the ticket? You will not be able to edit the ticket fields or change the
          assignee after the ticket is closed.
        </p>
        <DialogFooter>
          <DialogClose>
            <Button variant="outline"> Cancel </Button>
          </DialogClose>
          <Button variant="destructive" @click="$emit('close-ticket')"> Close Ticket </Button>
        </DialogFooter>
      </div>
    </DialogContent>
  </Dialog>
</template>
